import { FunctionComponent } from "react";
import { PlanItem as PlanItemDto } from "@dto/PlanItem";
import { Category } from "../Category/Category";
import { OrdinalIndicator } from "@ui-kit/OrdinalIndicator/OrdinalIndicator";
import { Image } from "@ui-kit/Image/Image";
import { AddRemoveButton } from "../../components/buttons/AddRemoveButton/AddRemoveButton";
import { AudioPlayerButton } from "../../media/AudioPlayer/AudioPlayerButton";
import { getEntityUrlPath } from "@lib/getEntityUrlPath";
import { NavLink } from "@modules/navigation/NavLink/NavLink";
import { Text } from "@ui-kit/Text/Text";

import "./PlanItem.css";
import { colors } from "@ui-kit/ConfigProvider/ConfigProvider";

interface PlanItemProps {
  planItem: PlanItemDto;
  ordinal: number;
  actionsEnabled?: boolean;
}

const PlanItem: FunctionComponent<PlanItemProps> = ({
  planItem,
  ordinal,
  actionsEnabled = true,
}) => {
  const coverPhotoUrl = planItem.plannable.coverPhotoUrl;
  const title = planItem.plannable.name;

  return (
    <NavLink
      to={getEntityUrlPath(
        planItem.plannable.slug,
        planItem.plannableId,
        planItem.plannableType,
      )}
      className="plan-item-container">
      <div className="ordinal-indicator">
        <OrdinalIndicator ordinal={ordinal} />
      </div>
      <div className="image">
        <Image src={coverPhotoUrl} alt={title} />
      </div>
      <div className="content">
        <Text variant="fontHeadingSmall" color={colors.black}>
          {title}
        </Text>
        <div className="category">
          <Category entity={planItem.plannable} />
        </div>
        {actionsEnabled && (
          <div className="plan-item-actions">
            <AddRemoveButton
              variant="small"
              id={planItem.plannableId}
              type={planItem.plannableType}
            />
            <AudioPlayerButton variant="list" entity={planItem.plannable} />
          </div>
        )}
      </div>
    </NavLink>
  );
};

export { PlanItem };
